"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var axios_1 = __importDefault(require("axios"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var texts_1 = __importDefault(require("../../../common/src/constrains/locale/texts"));
var ProductSelect = /** @class */ (function (_super) {
    __extends(ProductSelect, _super);
    function ProductSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.productItems = [{
                value: ' ',
                text: texts_1.default.ja.dictionary.select.default_text,
                price: ' '
            }];
        return _this;
    }
    ProductSelect.prototype.handleInput = function (newVal) {
        this.$emit('input', newVal);
        this.$emit('price-change', this.getPrice(newVal));
        this.$emit('product-change', this.getProductInfo(newVal));
    };
    ProductSelect.prototype.getPrice = function (newVal) {
        var currentProduct = this.productItems.filter(function (productItem) {
            return productItem['value'] === newVal;
        });
        if (currentProduct.length) {
            return currentProduct[0]['price'];
        }
        else {
            return '';
        }
    };
    ProductSelect.prototype.getProductInfo = function (newVal) {
        var currentProduct = this.productItems.filter(function (productItem) {
            return productItem['value'] === newVal;
        });
        if (currentProduct.length) {
            return {
                name: currentProduct[0]['text'],
                planName: currentProduct[0]['period'],
                month: currentProduct[0]['monthCount'],
                capacity: currentProduct[0]['capacity']
            };
        }
        else {
            return {};
        }
    };
    ProductSelect.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.priceBookIdChange()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductSelect.prototype.priceBookIdChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authToken, url_, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (value_checker_1.default.isBlank(this.priceBookId)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 1:
                        authToken = _a.sent();
                        url_ = this.$invokeUrlMaker.create("sales_force/get_pricebook_entry/" + this.priceBookId);
                        return [4 /*yield*/, axios_1.default.get(url_, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.data['priceBookEntryList']) {
                            this.productItems = response.data['priceBookEntryList'];
                            this.productItems.unshift({
                                value: ' ',
                                text: String(this.$t('dictionary.select.default_text')),
                                price: ' '
                            });
                            this.$emit('price-change', this.getPrice(this.value));
                            this.$emit('entry-change', response.data['priceBookEntryList']);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ProductSelect.prototype, "filterProductItems", {
        /**
         *
         */
        get: function () {
            var self_ = this;
            return this.productItems.filter(function (productItem) {
                // Product Cd の絞り込み。
                return value_checker_1.default.isBlank(self_.product) ||
                    value_checker_1.default.isBlank(productItem['value']) ||
                    productItem['family'] === self_.product;
            }).filter(function (productItem) {
                // 定員数による絞り込み
                return value_checker_1.default.isBlank(self_.capacity) ||
                    productItem['capacity'] === self_.capacity;
            }).filter(function (productItem) {
                // // 期間による絞り込み
                return value_checker_1.default.isBlank(self_.period) ||
                    productItem['period'] === self_.period;
            });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], ProductSelect.prototype, "priceBookId", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], ProductSelect.prototype, "value", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], ProductSelect.prototype, "product", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], ProductSelect.prototype, "capacity", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], ProductSelect.prototype, "period", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], ProductSelect.prototype, "disabled", void 0);
    __decorate([
        vue_property_decorator_1.Watch('priceBookId')
    ], ProductSelect.prototype, "priceBookIdChange", null);
    ProductSelect = __decorate([
        vue_property_decorator_1.Component
    ], ProductSelect);
    return ProductSelect;
}(vue_property_decorator_1.Vue));
exports.default = ProductSelect;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/ProductSelect.vue
// module id = EC85
// module chunks = 1